/**
 * 求職者に提案するか (推薦 PDF に載せるか。IN-M-011・DP-M-017・DP-M-018) の読み方と文言
 * (画面レイアウト_SCR-M-001.md §4.1〜§4.4・§5.2 No.7・§6.4.6、Issue #992)。
 */

// IN-M-011 の文言。「公開」だけでは何に公開するのか分からないため、PDF に載るかを書く (§4.1)
export const CANDIDATE_VISIBLE_LABEL = '求職者に提案する（PDF に載せる）';
// DP-M-018 の文言。チェックボックスの「（PDF に載せる）」の否定で、画面の言葉を 1 組にする (§4.2)
export const NOT_PROPOSED_BADGE = 'PDF に載せない';
// DP-M-017 の補足。画面の順位は全候補で振るため、PDF と番号がずれることを 1 回だけ伝える (§4.2)
export const RANK_RENUMBER_NOTE = 'PDF では提案する求人だけで順位を 1 から振ります。';
// §5.2 No.7 (BTN-M-003 ⑥ で押せない理由。サーバの 400 の文言と同じ)
export const NO_PROPOSED_MESSAGE = '求職者に提案する求人がありません。1 件以上にチェックを入れてください。';
// DP-M-017 で M = 0 (推薦候補がすべて求人プールに無い求人の枠) のとき。チェックできる求人が無いため、
// サーバの 400 ② (RPT-M-001 §4.6 No.3。求人が無くなった場合) と同じ文言にする (§4.2。PM の判断 2026-10-06、
// Issue #883)。NO_PROPOSED_MESSAGE (400 ① と同じ) はチェックできる求人があるときだけ使う
export const ALL_MISSING_FROM_POOL_MESSAGE =
    'PDF に載せられる求人がありません（求人が削除されています）。AI マッチングを実行し直してください。';

/**
 * 推薦の要素を、推薦 PDF に載せるか。`visible_to_candidate` が false のときだけ「載せない」とし、
 * true・項目が無い (BE の反映前)・それ以外は「載せる」とする (§6.4.6「設定の読み方」。
 * サーバの決め方〈PBI-002 §11.9〉と同じ)。
 *
 * @param {object|null|undefined} recommendation
 * @returns {boolean} 載せるなら true
 */
export function isVisibleToCandidate(recommendation) {
    return recommendation?.visible_to_candidate !== false;
}

/**
 * DP-M-017 の件数。visible は載せる候補の数、total は推薦候補の数。
 * isCounted が偽の候補 (求人プールに無い求人の枠。§4.4) は、どちらにも数えない (Issue #883)。
 *
 * @param {Array<object>|null|undefined} recommendations
 * @param {(recommendation: object) => boolean} [isCounted] 数える候補か (既定はすべて数える)
 * @returns {{visible: number, total: number}}
 */
export function countCandidateVisible(recommendations, isCounted = () => true) {
    const list = (Array.isArray(recommendations) ? recommendations : []).filter(isCounted);
    return { visible: list.filter(isVisibleToCandidate).length, total: list.length };
}

/**
 * 推薦の要素に、保存後の「載せるか」を入れた新しい要素を返す (元の要素は変えない)。
 *
 * @param {object} recommendation
 * @param {boolean} visible
 * @returns {object}
 */
export function withCandidateVisible(recommendation, visible) {
    return { ...recommendation, visible_to_candidate: visible };
}
